module.exports = __webpack_public_path__ + "img/Ilustraciones-Difarmer-3.3ff6e0fd.jpg";